<template>
  <div class="member-main">
    <ul class="title">
      <li class="active">忘记密码</li>
    </ul>
    <!-- 机构忘记密码 -->
    <el-form :model="organ" :rules="organRules" ref="organForm" v-show="type === 'organ'">
      <el-form-item prop="account">
        <el-input type="email" v-model="organ.account" placeholder="邮箱地址"></el-input>
      </el-form-item>
      <el-form-item prop="managerPhone">
        <el-select v-model="phoneCode" class="phone-areacode">
          <el-option
            v-for="(item, index) in phoneCodeList"
            :key="index"
            :label="`+${item.code}`"
            :value="`+${item.code}`"
          >
            <span style="float: left">{{ item.name }}</span>
            <span
              style="float: right; padding-left: 20px; color: #8492a6; font-size: 13px"
            >+{{ item.code }}</span>
          </el-option>
        </el-select>
        <el-input type="tel" v-model="organ.managerPhone" placeholder="管理员手机号" class="phone-input"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="imageVerifyCode" placeholder="图形验证码" class="image-code-input"></el-input>
        <img
          :src="imageCodeUrl"
          class="image-code"
          alt="点击切换验证码"
          title="点击切换验证码"
          @click="changeImageCode"
        >
      </el-form-item>
      <el-form-item prop="managerPhoneVerifyCode">
        <el-input
          type="number"
          v-model="organ.managerPhoneVerifyCode"
          placeholder="验证码"
          class="phone-code-input"
        ></el-input>
        <timer-button @click.native="onSendOrgaPhoneCode" ref="orgaPhoneCode"></timer-button>
        <!-- <el-button type="primary" class="phone-code-btn" @click="onSendOrgaPhoneCode">发送验证码</el-button> -->
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          :type="pwdType"
          v-model="organ.password"
          placeholder="新密码"
          @keyup.enter.native="onResetPasswordOrga"
        >
          <i class="el-icon-view el-input__icon" slot="suffix" @click="handlePwdIconClick"></i>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="btn-block" type="primary" @click="onResetPasswordOrga">提交</el-button>
      </el-form-item>
      <div class="member-bar">
        <div class="is-right">
          <router-link :to="{path: '/member/register', query: {type: 'organ'}}">新用户注册</router-link>
        </div>
      </div>
    </el-form>
    <!-- 个人忘记秘密 -->
    <el-form :model="personal" :rules="personalRules" ref="personalForm" v-show="type !== 'organ'">
      <el-form-item prop="account">
        <el-select v-model="phoneCode" class="phone-areacode">
          <el-option
            v-for="(item, index) in phoneCodeList"
            :key="index"
            :label="`+${item.code}`"
            :value="`+${item.code}`"
          >
            <span style="float: left">{{ item.name }}</span>
            <span
              style="float: right; padding-left: 20px; color: #8492a6; font-size: 13px"
            >+{{ item.code }}</span>
          </el-option>
        </el-select>
        <el-input type="tel" v-model="personal.account" placeholder="手机号" class="phone-input"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="imageVerifyCode" placeholder="图形验证码" class="image-code-input"></el-input>
        <img
          :src="imageCodeUrl"
          class="image-code"
          alt="点击切换验证码"
          title="点击切换验证码"
          @click="changeImageCode"
        >
      </el-form-item>
      <el-form-item prop="verifyCode">
        <el-input
          type="number"
          v-model="personal.verifyCode"
          placeholder="验证码"
          class="phone-code-input"
        ></el-input>
        <timer-button @click.native="onSendPersonalCode" ref="personalCode"></timer-button>
        <!-- <el-button type="primary" class="phone-code-btn" @click="onSendPersonalCode">发送验证码</el-button> -->
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          :type="pwdType"
          v-model="personal.password"
          placeholder="新密码"
          autocomplete="off"
          @keyup.enter.native="onResetPasswordPersonal"
        >
          <i class="el-icon-view el-input__icon" slot="suffix" @click="handlePwdIconClick"></i>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="btn-block" type="primary" @click="onResetPasswordPersonal">提交</el-button>
      </el-form-item>
      <div class="member-bar">
        <div class="is-right">
          <router-link :to="{path: '/member/register', query: {type: 'personal'}}">新用户注册</router-link>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import hash from 'hash.js'
import {
  getPhoneCode,
  getImageCode,
  sendCode,
  resetPassword
} from '@/api/zaiart'
import TimerButton from '../common/timerButton'

export default {
  components: { TimerButton },
  data: () => ({
    type: 'personal',
    phoneCodeList: [],
    phoneCode: '+86',
    sessionId: '',
    imageCodeUrl: '',
    imageVerifyCode: '',
    personal: { account: '', verifyCode: '', password: '' },
    personalRules: {
      account: { required: true, message: '请输入手机号', trigger: 'blur' },
      verifyCode: { required: true, message: '请输入验证码', trigger: 'blur' },
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
      ]
    },
    organ: {
      account: '',
      password: '',
      managerPhone: '',
      managerPhoneVerifyCode: ''
    },
    organRules: {
      account: [
        { required: true, message: '请输入邮箱地址', trigger: 'blur' },
        {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: 'blur,change'
        }
      ],
      managerPhone: {
        required: true,
        message: '请输入管理员手机号',
        trigger: 'blur'
      },
      managerPhoneVerifyCode: {
        required: true,
        message: '请输入管理员手机验证码',
        trigger: 'blur'
      },
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
      ]
    },
    pwdType: 'password'
  }),
  watch: {
    $route: function(route) {
      this.type = route.query.type
    }
  },
  methods: {
    // 初始化
    init() {
      this.getPhoneCode()
      this.changeImageCode()
    },
    // 获取手机区号
    getPhoneCode() {
      return getPhoneCode().then(response => {
        this.phoneCodeList = response.data.countries
      })
    },
    // 切换图形验证码
    changeImageCode() {
      this.sessionId = Math.random()
        .toString(36)
        .substr(2)
      this.imageCodeUrl = getImageCode(this.sessionId)
    },
    // 发送个人注册验证码
    onSendPersonalCode() {
      let param = {
        sessionId: this.sessionId,
        imageVerifyCode: this.imageVerifyCode,
        account: this.phoneCode + ' ' + this.personal.account,
        sendFuncType: 'FORGET_PASSWORD'
      }
      if (!this.personal.account) {
        this.$message.error('请输入手机号')
        return false
      } else if (!param.imageVerifyCode) {
        this.$message.error('请输入图形验证码')
        return false
      }
      // 验证码倒计时
      this.$refs.personalCode.start()
      this.sendCode(param).catch(() => {
        this.$refs.personalCode.stop()
      })
    },
    // 发送机构注册管理员手机验证码
    onSendOrgaPhoneCode() {
      let param = {
        sessionId: this.sessionId,
        imageVerifyCode: this.imageVerifyCode,
        account: this.phoneCode + ' ' + this.organ.managerPhone,
        sendFuncType: 'FORGET_PASSWORD'
      }
      if (!this.organ.managerPhone) {
        this.$message.error('请输入管理员手机号')
        return false
      } else if (!param.imageVerifyCode) {
        this.$message.error('请输入图形验证码')
        return false
      }
      // 验证码倒计时
      this.$refs.orgaPhoneCode.start()
      this.sendCode(param).catch(() => {
        this.$refs.orgaPhoneCode.stop()
      })
    },
    // 发送验证码
    sendCode(param) {
      return sendCode(param).then(response => {
        this.$message({
          type: 'success',
          message: '验证码已发送，请查收'
        })
      })
    },
    // 个人忘记密码
    onResetPasswordPersonal() {
      let isPass = true
      // 表单验证
      this.$refs.personalForm.validate(valid => {
        if (!valid) {
          isPass = false
          return false
        }
      })
      // 验证未通过
      if (!isPass) {
        return false
      }
      let param = JSON.parse(JSON.stringify(this.personal))
      param.account = `${this.phoneCode} ${param.account}`
      this.resetPassword(param)
    },
    // 机构忘记密码
    onResetPasswordOrga() {
      let isPass = true
      // 表单验证
      this.$refs.organForm.validate(valid => {
        if (!valid) {
          isPass = false
          return false
        }
      })
      // 验证未通过
      if (!isPass) {
        return false
      }
      let param = JSON.parse(JSON.stringify(this.organ))
      param.managerPhone = `${this.phoneCode} ${param.managerPhone}`
      this.resetPassword(param)
    },
    resetPassword(param) {
      param.password = this.setPassword(param.password)
      return resetPassword(param).then(response => {
        if (response.code === 1) {
          this.$alert('密码重置成功', '提示', {
            confirmButtonText: '去登录',
            callback: action => {
              this.$router.push('/')
            }
          })
        }
      })
    },
    // 密码显示隐藏
    handlePwdIconClick(e) {
      this.pwdType = this.pwdType !== 'password' ? 'password' : 'text'
    },
    // 密码加密
    setPassword(pwd) {
      return hash
        .sha256()
        .update(
          `ad5e38a3999d923fd852f834c4e4549652f61def3e48f6118cdab3a812615519${pwd}`
        )
        .digest('hex')
    }
  },
  created() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
    this.init()
  }
}
</script>
